import React, { useState } from "react"
import compose from "ramda/src/compose"
import { translate } from "react-i18next"
import moment from "moment"
import PropTypes from "prop-types"
import _isNil from "lodash/isNil"

import DateRange from "components/DateRangePicker"
import ModernFloatLabelInput from "shared/components/ModernFloatLabelInput"
import ModernButton from "shared/components/Button/ModernButton"
import ModernFloatLabelSelect from "shared/components/ModernFloatLabelSelect"

import styles from "./styles.css"

import isAfterDay from "react-dates/lib/utils/isAfterDay"
import { sendGtmEventFormSubmit } from "services/utils/sendGtm"
import {
  filterOptions,
  serviceOptions,
  statusOptions
} from "../utils/filterConstants"
import { formatPayloadProtocolFilter } from "../utils/formatPayload"

moment.locale("pt-br")

const IncidentFilterForm = ({ t, onFilter }) => {
  const [period, setPeriod] = useState({
    startDate: moment().subtract(1, "month"),
    endDate: moment()
  })
  const [filterData, setFilterData] = useState({
    type: filterOptions[0],
    data: null
  })

  const showSearch =
    filterData.type.value === "protocol" || filterData.type.value === "date"

  const isDisabledButton =
    (!filterData.data && filterData.type.value !== "date") ||
    _isNil(period.startDate) ||
    _isNil(period.endDate)

  const handleChangeInput = (e, filter) => {
    const value = e.value ? e : e.target.value

    if (filter === "filterType") {
      setFilterData({ type: value, data: "" })
    } else {
      setFilterData((prevState) => ({ ...prevState, data: value }))
    }
  }

  const handleFilterIncidents = () => {
    sendGtmEventFormSubmit("Protocolos - Filtragem")

    const payload = formatPayloadProtocolFilter(filterData, period)

    onFilter(payload)
  }

  const handleFocusChange = (focusedInput) => {
    setPeriod({ focusedInput })
  }

  const handleConfirm = (dates) => {
    setPeriod({
      ...dates
    })
  }

  const handleCancel = () => {
    setPeriod({
      startDate: moment(),
      endDate: moment()
    })
  }

  const changeDate = (start, end) => {
    setPeriod({
      startDate: start,
      endDate: end
    })
  }

  const isDayBlocked = (day) => isAfterDay(day, moment())

  return (
    <div className={styles.containerForm}>
      <ModernFloatLabelSelect
        id="type"
        name="type"
        label="Tipo de solicitação"
        options={filterOptions}
        margin="top_0"
        customStyles={customFloatLabel}
        onChange={(e) => handleChangeInput(e, "filterType")}
      />

      {showSearch && (
        <ModernFloatLabelInput
          id="search"
          preset="search"
          label="Buscar"
          containerClasses={styles.searchInput}
          disabled={filterData.type.value === "date"}
          onChange={(e) => handleChangeInput(e)}
          value={filterData.data}
        />
      )}

      {filterData.type.value === "statusDemand" && (
        <ModernFloatLabelSelect
          id="status"
          name="status"
          label="Status"
          options={statusOptions}
          margin="top_0"
          customStyles={customFloatLabel}
          onChange={(e) => handleChangeInput(e)}
          value={filterData.data}
        />
      )}

      {filterData.type.value === "typeClass" && (
        <ModernFloatLabelSelect
          id="service"
          name="service"
          label="Assunto"
          options={serviceOptions}
          margin="top_0"
          customStyles={customFloatLabel}
          onChange={(e) => handleChangeInput(e)}
          value={filterData.data}
        />
      )}

      <DateRange
        startDate={period.startDate}
        endDate={period.endDate}
        focusedInput={period.focusedInput}
        onFocusChange={handleFocusChange}
        onDatesChange={({ startDate, endDate }) =>
          changeDate(startDate, endDate)
        }
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        isOutsideRange={false}
        anchorDirection="right"
        disabled
        isDayBlocked={isDayBlocked}
      />

      <ModernButton
        shape="full"
        size="small"
        buttonColor="deep_sea_green"
        text="Filtrar"
        textColor="white"
        textSize="small"
        withBorderRadius
        onClick={handleFilterIncidents}
        classNames={styles.buttonFilter}
        isDisabled={isDisabledButton}
      />
    </div>
  )
}

IncidentFilterForm.propTypes = {
  t: PropTypes.func,
  onFilter: PropTypes.func
}

const customFloatLabel = {
  control: (provided) => ({
    ...provided,
    width: "184px!important"
  })
}
const enhance = compose(translate())

export default enhance(IncidentFilterForm)



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/IncidentFilterForm/index.js